// src/auth/authStorage.js
// Single source of truth for where the auth token/user live.
//
// "Remember me" checked  -> localStorage   (survives closing the browser, until token expiry/logout)
// "Remember me" unchecked -> sessionStorage (cleared when the browser/tab is closed)

const TOKEN_KEY = 'auth_token';
const USER_KEY = 'auth_user';

// Persist a freshly-logged-in session in the storage matching the user's choice,
// and wipe the other storage so there's never more than one source of truth.
export const setAuthSession = (token, user, remember) => {
  const store = remember ? localStorage : sessionStorage;
  const other = remember ? sessionStorage : localStorage;

  store.setItem(TOKEN_KEY, token);
  store.setItem(USER_KEY, JSON.stringify(user));
  other.removeItem(TOKEN_KEY);
  other.removeItem(USER_KEY);
};

export const getToken = () =>
  localStorage.getItem(TOKEN_KEY) || sessionStorage.getItem(TOKEN_KEY);

export const getStoredUser = () => {
  const raw = localStorage.getItem(USER_KEY) || sessionStorage.getItem(USER_KEY);
  try {
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

// Update the cached user in whichever storage currently holds the active session.
export const updateStoredUser = (user) => {
  if (localStorage.getItem(TOKEN_KEY)) {
    localStorage.setItem(USER_KEY, JSON.stringify(user));
  } else if (sessionStorage.getItem(TOKEN_KEY)) {
    sessionStorage.setItem(USER_KEY, JSON.stringify(user));
  }
};

export const clearAuthSession = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
  sessionStorage.removeItem(TOKEN_KEY);
  sessionStorage.removeItem(USER_KEY);
};
